<div class="content-container">
  <!-- Header Section Start -->
<section id="neet-top-pannel">
  <div class="neet-wrapper">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-4 text-center m-hide rht-img">
        <figure>
          <img src="assets/img/jee-banner-img.png" alt="" class="img-fluid">
        </figure>
      </div>
      <div class="col-12 col-md-12 col-lg-8 dddddd">
        <div class="rht-content">
          <div class="m-hide-570">
            <div class="neet-main-title">
              <h1>Ace JEE</h1>
              <p>Main and Advanced <br> with confidence </p>
            </div>
            <!-- <h1>NEET 2021</h1>
            <p>Boost your rank with us</p> -->
            <h6>LIVE Classes | Test Series | Mock Tests | Previous Year Papers</h6>
          </div>
          <!-- </div> -->
          <!-- <h5>Start learning for FREE Now</h5> -->
          <div class="t-center m-show-570">
            <span id="neet-heading">Ace JEE <br>
              <p>Main and Advanced <br> with confidence </p>
            </span>
            <h6>LIVE Classes | Test Series | Mock Tests | Previous Year Papers</h6>
          </div>
          <div class="m-show img-container">
            <figure>
              <img src="assets/img/jee-banner-img.png" alt="" class="img-fluid">
            </figure>

            <div [class.srichaitanya-tenant]="tenant=='srichaitanya'" class="form-wrapper">
              <ng-container *ngIf="tenant=='srichaitanya';else notSrichaitanyaFormMobile">
                <div class="form-group">
                  <form [formGroup]="sriChaitanyaStartForm" class="common-intl-phone-form">
                    <input [maxlength]="SCMaxLength" formControlName="admissionNumber" [placeholder]="SCPlaceHolder"
                      class="form-control common-intl-phone">
                    <button (click)="openAdmissionLoginForm(sriChaitanyaStartForm.value)"
                      [disabled]="!customSriChaitanyaStartFormValid || !sriChaitanyaStartForm.valid " type="button"
                      class="btn btn-primary btn-danger">START LEARNING</button>
                  </form>
                </div>
              </ng-container>
              <ng-template #notSrichaitanyaFormMobile>
                <!-- {{tenant}} -->
                <form method="POST">
                  <app-common-mobile-number class="assessments-common-mobile-number"
                    (mobileNumberChange)="doSearch($event)" (callSignUp)="signup('jee', searchValue)">
                  </app-common-mobile-number>
                </form>
              </ng-template>
              
              <div class="d-flex justify-content-center IL_sc-click font-weight-bold assessment_mt-10">
                <span *ngIf="tenant == 'srichaitanya';else others">Forgot Password? - <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">Click Here</span></span>
                <ng-template #others>
                  <span>Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn" style="color: white !important">click here</span>  to login</span>
                </ng-template>  
              </div>
            </div>
          </div>

          <div [class.srichaitanya-tenant]="tenant=='srichaitanya'" class="m-hide form-wrapper">
            <ng-container *ngIf="tenant=='srichaitanya';else notSrichaitanyaForm">
              <div class="form-group">
                <form [formGroup]="sriChaitanyaStartForm" class="common-intl-phone-form">
                  <input [maxlength]="SCMaxLength" formControlName="admissionNumber" [placeholder]="SCPlaceHolder"
                    class="form-control common-intl-phone">
                  <button (click)="openAdmissionLoginForm(sriChaitanyaStartForm.value)"
                    [disabled]="!customSriChaitanyaStartFormValid || !sriChaitanyaStartForm.valid " type="button"
                    class="btn btn-primary btn-danger">START LEARNING</button>
                </form>
              </div>
            </ng-container>
            <ng-template #notSrichaitanyaForm>
              <form method="POST">
                <app-common-mobile-number class="assessments-common-mobile-number"
                  (mobileNumberChange)="doSearch($event)" (callSignUp)="signup('jee', searchValue)">
                </app-common-mobile-number>
              </form>
            </ng-template>
            
            <div class="d-flex justify-content-center IL_sc-click font-weight-bold assessment_mt-10">
              <span *ngIf="tenant == 'srichaitanya';else others">Forgot Password? - <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">Click Here</span></span>
              <ng-template #others>
                <span>Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn" style="color: white !important">click here</span>  to login</span>
              </ng-template>  
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Header Section End -->
<!-- Jee course section -->
<section id="neet-courses-pannel">
  <div class="ncp-inner">
    <div class="row">

      <div class="col-12 col-lg-6 col-md-12 col-sm-12 mt-100">
        <div class="feature-box">
          <div class="feature-icon">
            <img src="assets/img/ineet-one.png" alt="">
            <div class="feature-text">
              <h4>FREE Live Classes</h4>
            </div>
          </div>
          <p>Expert faculties to help you get top ranks in JEE. Register for your free session,
            Attend Live sessions, quizzes to help you beat the competition or <span><a routerLink='/jee-liveclasses'
                class="explore-text">explore more</a></span></p>
          <div class="feature-clsbtn">
            <p>Live classes | Strategies | Tips & Tricks </p>
            <!-- <div class="reg-for-btn">
              <a (click)="openDialog('Liveclass')"><button type="button" class="reg-btn">START FOR
                  FREE</button></a>
            </div> -->
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6 col-md-12 mt-100">
        <div class="feature-box">
          <div class="feature-icon">
            <img src="assets/img/ineet-two.png" alt="">
            <div class="feature-text">
              <h4>TEST SERIES</h4>
            </div>
          </div>
          <p>Assess where you stand compared to others by taking synchronized tests with students across
            the nation and improve your rank. Register for free.
            <!-- or <span><a routerLink='/testseries' class="explore-text">explore more</a></span></p> -->
          <div class="feature-clsbtn">
            <p>All subject covered | Scheduled Tests</p>
            <!-- <div class="reg-for-btn">
              <a (click)="openDialog('Testseries')"><button type="button" class="reg-btn">START FOR
                  FREE</button></a>
            </div> -->
          </div>
        </div>
      </div>

    </div>

    <div class="row">

      <div class="col-12 col-lg-6 col-md-12 mt-100 mb-100">
        <div class="feature-box">
          <div class="feature-icon">
            <img src="assets/img/ineet-three.png" alt="">
            <div class="feature-text">
              <h4>Mock Tests (MCT's)</h4>
            </div>
          </div>
          <p>Take mock tests with simulated test environment to improve your speed and accuracy.</p>
          <div class="feature-clsbtn">
            <p></p>
            <!-- <div class="reg-for-btn">
              <a (click)="openDialog('Mocktest')"><button type="button" class="reg-btn">START FOR
                  FREE</button></a>
            </div> -->
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6 col-md-12 mt-100 mb-100">
        <div class="feature-box">
          <div class="feature-icon">
            <img src="assets/img/ineet-four.png" alt="">
            <div class="feature-text">
              <h4>Previous Year Papers (PYP's)</h4>
            </div>
          </div>
          <p>Revise and practice with previous year papers to stay on top of the latest pattern and trends of
            questions.</p>
            <div class="feature-clsbtn">
              <p></p>
              <!-- <div class="reg-for-btn">
                <a (click)="openDialog('pyps')"><button type="button" class="reg-btn">START FOR
                    FREE</button></a>
              </div> -->
            </div>
        </div>
      </div>


      <!-- <div class="col-12 col-md-4 mb-55">
        <div class="neet-course-box" id="neet-course-box-4">
          <figure>
            <img src="assets/img/mtct-icon.svg" alt="">
          </figure>
          <h4>Mock Tests <br> (MCT's)</h4>
          <p>Take mock tests with simulated test environment to improve your speed and accuracy.</p>
        </div>
      </div>
      <div class="col-12 col-md-4 mb-55">
        <div class="neet-course-box" id="neet-course-box-5">
          <figure>
            <img src="assets/img/pyp-icon.svg" alt="">
          </figure>
          <h4>Previous Year Papers <br>(PYP's)</h4>
          <p>Revise and practice with previous year papers to stay on top of the latest pattern and trends of questions.
          </p>
        </div>
      </div>
      <div class="col-12 col-md-4 mb-55">
        <div class="neet-course-box" id="neet-course-box-6">
          <figure>
            <img src="assets/img/Result-Oriented-curriculum-icon.svg" alt="">
          </figure>
          <h4>Result-Oriented curriculum</h4>
          <p>Steer yourself towards smart learning to improve your performance.</p>
        </div>
      </div> -->
    </div>

    <!-- <div id="live-class-box-wrapper">
      <div class="row">
        <div class="col-12">
          <div class="live-class-box">
            <div class="text">
              <h6>JEE Live Classes</h6>
              <p>Live classes with India's top educators for preparation of JEE.</p>
            </div>
            <div class="btn-area">
              <button type="button" class="btn btn-primary btn-register"
                (click)="openDialog('Liveclasses')">REGISTER</button>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</section>
<!-- Jee course section end -->
<!-- Footer Start -->
<app-footer></app-footer>
</div>